import { useRef } from 'react';
import throttle from 'hs-lodash/throttle';
export function useThrottledFunction(fn, delay, options) {
  const functionRef = useRef(fn);
  const throttledFunctionRef = useRef();
  if (!throttledFunctionRef.current) {
    throttledFunctionRef.current = throttle((...args) => {
      return functionRef.current(...args);
    }, delay, options);
  }
  functionRef.current = fn;
  return throttledFunctionRef.current;
}